import React, { useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { FaArrowLeft, FaSearch } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';

export default function FollowEsp(params) {
  const [protocolo, setProtocolo] = useState('')

  const {buscaRelatoPeloUuid} = useFirestore()
  const nav = useNavigate()
  const { addAlert } = useAlert()


  const handleSubmit = (e) => {
    e.preventDefault()

    buscaRelatoPeloUuid(protocolo)
      .then((res) => nav('/es/acompanhar',{state: {relato : res}}))
      .catch((e) => addAlert('¡Ha ocurrido un problema inesperado!', "error"))
  }

  return(
    <div>
      <Navbar lang={'esp'}/>
      <main className='flex mt-40 flex-col'>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto h-[75vh]' >
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'><FaSearch />SEGUIR REPORTE</h1>
            <a className='flex items-center text-base text-secondary gap-2 font-semibold' href="/es/inicial">
              <FaArrowLeft />
              <p className='hidden lg:block'>VOLVER</p>
            </a>
          </div>
          <hr  className='border-background mb-8'/>
          <form onSubmit={handleSubmit} className="bg-background flex flex-col justify-start p-8">
            <label className='flex flex-col text-xl text-secondary font-semibold' htmlFor="protocolo">Ingrese su número de protocolo a continuación:
              <input className='p-2 rounded-md mt-4 lg:w-1/2' type="text" id='protocolo' onChange={e => setProtocolo(e.target.value)}/>
            </label>
            <input 
              type="submit" 
              value="ACCESO" 
              className={`bg-secondary text-white lg:w-3/12 px-8 py-4 mt-8 rounded-md font-semibold ${protocolo === '' ? 'hover:cursor-not-allowed' : ' hover:bg-primary hover:cursor-pointer'}`} 
              disabled={protocolo === ''} 
              title={protocolo === '' ? 'Protocolo em branco' : ''}
              />
          </form>
        </section>
      </main>
      <Footer />
    </div>
  )
};
